export default __webpack_public_path__ + "static/media/rarity-img4.d5f8883a.png";